<template>
  <v-container fluid class="pa-0">
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              Notification Trigger
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="rowClass">
          <v-col
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
        <router-link
          :to="{
            name: 'bulkNotification',
          }"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-account-multiple"
            color="warning"
            cardTitle="bulk Notification Trigger"
            style="max-width: 500px;"
          >
          </clickable-card>
        </router-link>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
        <router-link
          :to="{
            name: 'dummyNotificationTrigger',
          }"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-account-group"
            color="pink"
            cardTitle="dummy Notification Trigger"
            style="max-width: 500px;"
          >
          </clickable-card>
        </router-link>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
        <router-link
          :to="{
            name: 'reportNotificationcount',
          }"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-account-group"
            color="pink"
            cardTitle="report Notification Count"
            style="max-width: 500px;"
          >
          </clickable-card>
        </router-link>
        </v-col>
      </v-row>
    </v-card>
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-data-table
          :headers="headers"
          :items="notificationData"
          :page.sync="currentPage"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="totalCount"
          :footer-props="{
            'items-per-page-options': [10, 20, 40]
          }"
          :loading="loading"
          class="elevation-1"
          item-key="id"
          @update:page="handlePageChange"
          @update:items-per-page="handleItemsPerPageChange"
        >
          <!-- <template v-slot:item.accordion="{ item }">
            <v-btn
              icon
              small
              @click="toggleAccordion(item)"
            >
              <v-icon>{{ item.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </template> -->
          <template v-slot:item.summary="{ item }">
            <div>
              <div class="mt-2">
                <v-chip color="success" small class="ma-1">
                  Completed: {{ item.completed }}
                </v-chip>
                <v-chip color="warning" small class="ma-1">
                  Pending: {{ item.pending }}
                </v-chip>
              </div>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-4">
              <div class="summary-content">
                <strong>Summary:</strong> {{ item.body }}
                <div class="mt-2">
                  <v-chip color="success" small class="ma-1">
                    Completed: {{ item.completed }}
                  </v-chip>
                  <v-chip color="warning" small class="ma-1">
                    Pending: {{ item.pending }}
                  </v-chip>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:item.button="{ item }">
            <v-btn
              color="primary"
              small
              @click="triggerNotification(item)"
            >
              Trigger
            </v-btn>
            </template>
        </v-data-table>
      </v-card>
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'notificationTrigger',
  components: { ClickableCard },
  data () {
    return {
      headers: [
        // { text: '', value: 'accordion', sortable: false, align: 'center', width: '80px' },
        { text: 'Module Name', value: 'moduleName', sortable: true },
        { text: 'User Type', value: 'userType', sortable: true },
        { text: 'Title', value: 'title', sortable: true },
        { text: 'Ref Parameter', value: 'ref', sortable: false },
        { text: 'Discription', value: 'body', sortable: false },
        { text: 'Trigger At', value: 'triggerTime', sortable: true },
        // { text: 'Completed', value: 'completed', sortable: true },
        // { text: 'Pending', value: 'pending', sortable: true },
        { text: 'Created By', value: 'createdBy', sortable: true },
        { text: 'Summary', value: 'summary', sortable: false },
        { text: 'Count', value: 'count', sortable: true },
        { text: 'Trigger', value: 'button', sortable: false }
      ],
      notificationData: [],
      currentPage: 1,
      itemsPerPage: 10,
      totalCount: 0,
      loading: false
    }
  },
  created () {
    this.getNotificationData()
  },

  methods: {
    toggleAccordion (item) {
      item.expanded = !item.expanded
      this.$forceUpdate()
    },
    async getNotificationData () {
      this.loading = true
      try {
        const response = await http.get(`${constants.API_URL}/api/admin/app-notification/summary`, {
          params: {
            page: this.currentPage,
            limit: this.itemsPerPage
          }
        })

        if (response.data && response.data.success) {
          this.notificationData = response.data.data.map(item => ({
            moduleName: item.moduleName || '',
            userType: item.userType || '',
            title: item.title || '',
            triggerTime: item.triggerDate ? `${item.triggerDate} ${item.triggerTime || ''}`.trim() : 'N/A',
            body: item.pushN_message || '',
            moduleURL: item.moduleURL || '',
            createdBy: item.createdBy || '',
            count: item.count || 0,
            completed: item.completedCount || 0,
            pending: item.pendingCount || 0,
            moduleUrl: item.moduleURL || ''
          }))
          // Extract 'ref' query parameter from moduleURL if present
          this.notificationData.forEach(item => {
            const url = new URL(item.moduleURL, window.location.origin)
            const refParam = url.searchParams.get('ref')
            if (refParam) {
              item.ref = refParam
            }
          })
          this.totalCount = response.data.totalCount || 0
        }
      } catch (err) {
        this.errMsg(err.response?.data?.message || 'Failed to fetch notification data')
      } finally {
        this.loading = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    handlePageChange (newPage) {
      this.currentPage = newPage
      this.getNotificationData()
    },
    handleItemsPerPageChange (newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage
      this.currentPage = 1
      this.getNotificationData()
    },
    async triggerNotification (item) {
      try {
        const response = await http.get(`${constants.API_URL}/api/admin/app-notification/common-push`, {
          params: { moduleName: item.moduleName }
        })
        this.$buefy.dialog.alert({
          message: response.data?.message || 'Notification triggered successfully',
          type: 'is-success',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: 'mdi-check-circle',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        // Refresh only the triggered item's data
        this.getNotificationData()
      } catch (err) {
        this.$buefy.dialog.alert({
          message: err.response?.data?.message || 'Failed to trigger notification',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: 'mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
<style scoped>
.rowClass {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
